import { Button, Text, EmptyData } from '@intigral/shared';
import { __ } from '../../../../translations';
const NoContentBanner = ({ onChangeMood }) => {
    return (
        <div className="container full-width">
            <EmptyData>
                <Text as="p" margin="0" size={{ default: '14', md: '20' }}>
                    {__('no_content_available')}
                </Text>
                <Button primary compact onClick={onChangeMood}>
                    {__('moods_change_mood_text')}
                </Button>
            </EmptyData>
        </div>
    );
};

export default NoContentBanner;
